import { IMetaModel } from '@/modules/core/common/services/GridService';

// Trzyma baseUrl i permissions per moduleId
export const moduleBaseUrlCache = new Map<number, Promise<{ baseUrl: string | null; permissions: Record<string, IMetaModel> }>>();
